import type { Compare } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import type { ConfigurationTemplateFunctionValue } from '../../types/templateModel'
import { ComparableDocumentationDiff } from './ComparableDocumentationDiff'
import { ConfigurationTemplateFunctionValueExpresssionDiff } from './ConfigurationTemplateFunctionValueExpresssionDiff'
import { DiffPopoverLayout } from './DiffPopoverLayout'
import { TemplateFieldDiffHeader } from './TemplateFieldDiffHeader'
import { useCompareContext } from './valueSetupCompareContext'

export const ConfigurationTemplateFunctionValueDiff = ({
  current,
  compare,
}: Compare<ConfigurationTemplateFunctionValue>) => {
  const translate = useTranslate()
  const { shouldCompare } = useCompareContext()

  return (
    <DiffPopoverLayout>
      <div className="mb-8 grid grid-cols-2 gap-x-24">
        <TemplateFieldDiffHeader
          current={current?.origin}
          compare={compare?.origin}
        />
      </div>
      <div className="flex flex-col gap-y-4">
        {shouldCompare('defaultValue') && (
          <ConfigurationTemplateFunctionValueExpresssionDiff
            title={translate('diffPopover.field.defaultValue')}
            current={current}
            compare={compare}
          />
        )}
        {shouldCompare('documentation') && (
          <ComparableDocumentationDiff
            current={current?.documentation?.value}
            compare={compare?.documentation?.value}
          />
        )}
      </div>
    </DiffPopoverLayout>
  )
}
